import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Button,
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Avatar,
  Stack,
  Switch,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import LocalPhoneTwoToneIcon from "@mui/icons-material/LocalPhoneTwoTone";
import { useNavigate } from "react-router-dom";
import useSession from "../../CustomHooks/useSession";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { LoadingButton } from "@mui/lab";
import axiosInstance, { MinioUrl } from "../../Api/axios.instance";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

const EXPERIENCE_OPTIONS = [
  "0 – 1 year ",
  "1 – 3 years",
  "3 – 5 years",
  "5 – 10 years",
  "10+ years",
];

export default function StaffList({
  staff,
  refreshStaff,
  refreshPending,
  refreshLeftStaff,
  subjects,
}) {
  const [staffArray, setStaffArray] = useState([]);
  const navigate = useNavigate();
  const { currentPage, accesLevel } = useSession();
  const UserData = JSON.parse(localStorage.User);
  const isSchoolHR = UserData?.username === "schoolhr";
  const [currentPageCRUD] = useState(currentPage[0] ? currentPage[0] : "");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openAnchor = Boolean(anchorEl);

  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [editImgBase, setEditImgBase] = useState("");
  const [designations, setDesignations] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [reasonOptions, setReasonOptions] = useState([]);

  // ---- Teacher Exit modal state ----
  const [openExit, setOpenExit] = useState(false);
  const [exitData, setExitData] = useState({});

  useEffect(() => {
    const sortedStaff = [...staff].sort((a, b) => {
      const desigA = a.Designation?.TeachersDesignationId ?? 999;
      const desigB = b.Designation?.TeachersDesignationId ?? 999;
      if (desigA !== desigB) return desigA - desigB;

      if (!a.DateJoining) return 1;
      if (!b.DateJoining) return -1;
      return new Date(b.DateJoining) - new Date(a.DateJoining);
    });
    setStaffArray(sortedStaff);
  }, [staff]);

  const formatDate = (date) => {
    if (!date) return "Not Defined";
    return dayjs(date).format("DD-MM-YYYY");
  };

  const _mapIsPrimary = (val) => {
    if (val === true || val === 1 || val === "Primary") return "Primary";
    if (val === false || val === 0 || val === "Secondary") return "Secondary";
    if (val === 2 || val === "2" || val === "KG") return "KG";
    return "";
  };

  useEffect(() => {
    const _fetchReasons = async () => {
      try {
        const { data } = await axiosInstance.get(
          "/variables/reason-for-leaving",
        );
        setReasonOptions(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    _fetchReasons();
  }, []);

  useEffect(() => {
    _fetchDesignations();
    _fetchQualifications();
    _fetchCertifications();
  }, []);

  const _fetchDesignations = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/designations",
      );
      if (status === 200) setDesignations(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchQualifications = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/qualifications",
      );
      if (status === 200) setQualifications(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchCertifications = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/certifications",
      );
      if (status === 200) setCertifications(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _onDetailsClick = (details) => (e) => {
    navigate(`staffDetails/${details.SchoolTeachersQId}`, {
      state: { staffDetails: details },
    });
  };

  const handleAnchorClose = () => setAnchorEl(null);

  const handleIconClick = (row) => (event) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const _handleApprove = async (row) => {
    try {
      await axiosInstance.put(`/teachers/${row.SchoolTeachersQId}/approve`);
      if (refreshStaff) refreshStaff();
    } catch (error) {
      console.log(error);
    }
  };

  const _onSubjectClick = (subdetails) => (e) => {
    navigate(`subjectDetails/${subdetails.SchoolTeachersQId}`, {
      state: { subjectDetails: subdetails },
    });
  };

  const _onNumberClick = (number, type) => (event) => {
    if (type === "CELL") window.open(`tel:${number}`);
    else if (type === "WHATSAPP")
      window.open(`https://wa.me/15551234567`, "_blank").focus();
  };

  const _renderContact = (row) => (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
    >
      {row.ContactNo ? (
        <Chip
          onClick={_onNumberClick(row.ContactNo, "CELL")}
          icon={<LocalPhoneTwoToneIcon fontSize="small" />}
          label={`CELL: ${row.ContactNo}`}
          variant="outlined"
        />
      ) : (
        "Not Defined"
      )}
    </Stack>
  );

  // ---------------- EDIT MODAL ----------------
  const handleEditOpen = () => {
    setEditData({
      ...selectedRow,
      ContactNo: selectedRow.ContactNo
        ? String(selectedRow.ContactNo).trim()
        : "",
    });
    setEditImgBase(
      selectedRow.TeacherPicture
        ? `${MinioUrl}/teacherpictures/${selectedRow.TeacherPicture}`
        : "",
    );
    setOpenEdit(true);
    handleAnchorClose();
  };

  const handleEditClose = () => {
    setOpenEdit(false);
    setEditData({});
    setEditImgBase("");
  };

  const _handleEditChange = (e) => {
    setEditData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const _handleEditImageSelect = (e) => {
    const file = e.currentTarget.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      alert("File size must be less than 2MB.");
      return;
    }
    setEditData((prev) => ({ ...prev, TeacherPicture: file }));
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => setEditImgBase(event.target?.result);
  };

  const _onEditSubmit = async () => {
    try {
      const formData = new FormData();
      const fields = [
        "TeachersDesignationId",
        "CertificateId",
        "QualificationId",
        "TeacherName",
        "TeacherNameUrdu",
        "FirstSalary",
        "Allowance",
        "CNIC",
        "DateJoining",
        "DateLeft",
        "ContactNo",
        "TeacherCode",
        "DateOfBirth",
        "MaritalStatus",
        "ExperienceOfTeaching",
        "SubjectOfExperience",
        "HiredSubject",
        "ReasonForLeaving",
        "LeftStatus",
        "WarningStatus",
        "SalaryDemand",
        "BankAccount",
        "IsPrimary",
        "TypeOfHiring",
        "Address",
        "DataEntryOperator",
        "DateDataEntry",
      ];
      // fields.forEach((f) => formData.append(f, editData[f] ?? ""));
      fields.forEach((f) => {
        let value = editData[f] ?? "";

        if (f === "ContactNo") {
          value = String(value).trim();
        } else if (f === "IsPrimary") {
          value = _mapIsPrimary(editData.IsPrimary);
        }

        formData.append(f, value);
      });
      if (editData.TeacherPicture instanceof File) {
        formData.append("TeacherPicture", editData.TeacherPicture);
      }

      const { status } = await axiosInstance.put(
        `/teachers/${editData.SchoolTeachersQId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (status === 200) {
        handleEditClose();
        if (refreshStaff) refreshStaff();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------- TEACHER EXIT MODAL ----------------
  const handleExitOpen = () => {
    setExitData({ ...selectedRow });
    setOpenExit(true);
    handleAnchorClose();
  };

  const handleExitClose = () => {
    setOpenExit(false);
    setExitData({});
  };

  const _handleExitChange = (e) => {
    setExitData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const _onExitSubmit = async () => {
    if (
      !exitData.DateLeft ||
      !exitData.ReasonForLeaving ||
      !exitData.LeftStatus
    ) {
      alert("Please fill Date Left, Reason for Leaving and Status.");
      return;
    }
    try {
      const formData = new FormData();
      const fields = [
        "TeachersDesignationId",
        "CertificateId",
        "QualificationId",
        "TeacherName",
        "TeacherNameUrdu",
        "FirstSalary",
        "CNIC",
        "DateJoining",
        "DateLeft",
        "ContactNo",
        "TeacherCode",
        "DateOfBirth",
        "MaritalStatus",
        "ExperienceOfTeaching",
        "SubjectOfExperience",
        "HiredSubject",
        "ReasonForLeaving",
        "LeftStatus",
        "WarningStatus",
        "SalaryDemand",
        "BankAccount",
        "IsPrimary",
        "TypeOfHiring",
        "Address",
        "DataEntryOperator",
        "DateDataEntry",
      ];
      // fields.forEach((f) => formData.append(f, exitData[f] ?? ""));
      fields.forEach((f) => {
        let value = exitData[f] ?? "";

        if (f === "ContactNo") {
          value = String(value).trim();
        } else if (f === "IsPrimary") {
          value = _mapIsPrimary(exitData.IsPrimary);
        }

        formData.append(f, value);
      });

      const { status } = await axiosInstance.put(
        `/teachers/${exitData.SchoolTeachersQId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (status === 200) {
        handleExitClose();
        if (refreshStaff) refreshStaff();
        if (refreshPending) refreshPending();
        if (refreshLeftStaff) refreshLeftStaff();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Full Name</TableCell>
            <TableCell align="center">CNIC</TableCell>
            <TableCell align="center">Designation</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Cell #</TableCell>
            <TableCell align="center">Address</TableCell>
            <TableCell align="center">Date Joining</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPageCRUD.read &&
            staffArray.map((row, index) => (
              <TableRow
                key={String(index)}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.TeacherName || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.CNIC || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.Designation
                    ? row.Designation.TeachersDesignation
                    : "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.Status === "Approved" ? (
                    <span style={{ color: "#1976d2", fontWeight: 600 }}>
                      Approved
                    </span>
                  ) : ["Left", "Resigned", "Terminated", "Retired"].includes(
                      row.Status,
                    ) ? (
                    <span style={{ color: "#d32f2f", fontWeight: 600 }}>
                      {row.Status}
                    </span>
                  ) : (
                    <>
                      <span style={{ color: "#f57c00", fontWeight: 600 }}>
                        Pending
                      </span>
                      {isSchoolHR && (
                        <Switch
                          size="small"
                          checked={false}
                          onChange={() => _handleApprove(row)}
                        />
                      )}
                    </>
                  )}
                </TableCell>
                <TableCell align="center">{_renderContact(row)}</TableCell>
                <TableCell align="center">
                  {row.Address || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {formatDate(row.DateJoining)}
                </TableCell>
                <TableCell align="right">
                  <IconButton onClick={handleIconClick(row)}>
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openAnchor}
        onClose={handleAnchorClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        <MenuItem
          onClick={(e) => {
            _onDetailsClick(selectedRow)(e);
            handleAnchorClose();
          }}
        >
          Teacher Details
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            _onSubjectClick(selectedRow)(e);
            handleAnchorClose();
          }}
        >
          Subject Details
        </MenuItem>
        {isSchoolHR && <MenuItem onClick={handleEditOpen}>Edit</MenuItem>}
        {isSchoolHR && (
          <MenuItem onClick={handleExitOpen}>Teacher Exit</MenuItem>
        )}
      </Menu>

      {/* ---------------- EDIT DIALOG ---------------- */}
      <Dialog fullWidth maxWidth="md" open={openEdit} onClose={handleEditClose}>
        <DialogTitle>Edit Teacher Details</DialogTitle>
        <DialogContent>
          <Stack sx={{ mb: 3, mt: 1 }}>
            <Paper sx={{ p: 1, width: 150 }} square>
              <Avatar
                variant="square"
                src={
                  editImgBase === ""
                    ? "https://www.pngitem.com/pimgs/m/99-998739_dale-engen-person-placeholder-hd-png-download.png"
                    : editImgBase
                }
                sx={{ width: 130, height: 130, objectFit: "cover" }}
              />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                sx={{ mt: 1 }}
              >
                <Button component="label" size="small" variant="text">
                  Change Picture
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={_handleEditImageSelect}
                  />
                </Button>
              </Stack>
            </Paper>
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                label="Full Name"
                fullWidth
                size="small"
                name="TeacherName"
                value={editData.TeacherName || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="CNIC"
                fullWidth
                size="small"
                name="CNIC"
                value={editData.CNIC || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Designation"
                fullWidth
                size="small"
                name="TeachersDesignationId"
                value={editData.TeachersDesignationId || ""}
                onChange={_handleEditChange}
              >
                {designations.map((d) => (
                  <MenuItem
                    key={d.TeachersDesignationId}
                    value={d.TeachersDesignationId}
                  >
                    {d.TeachersDesignation}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Address"
                fullWidth
                size="small"
                name="Address"
                value={editData.Address || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Contact No"
                fullWidth
                size="small"
                name="ContactNo"
                value={editData.ContactNo || ""}
                onChange={_handleEditChange}
                inputProps={{ maxLength: 15 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="Date of Birth"
                  inputFormat="DD-MM-YYYY"
                  value={editData.DateOfBirth || null}
                  onChange={(newValue) =>
                    setEditData((prev) => ({
                      ...prev,
                      DateOfBirth: dayjs(newValue).format("YYYY-MM-DD"),
                    }))
                  }
                  renderInput={(params) => (
                    <TextField fullWidth size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="Date of Joining"
                  inputFormat="DD-MM-YYYY"
                  value={editData.DateJoining || null}
                  onChange={(newValue) =>
                    setEditData((prev) => ({
                      ...prev,
                      DateJoining: dayjs(newValue).format("YYYY-MM-DD"),
                    }))
                  }
                  renderInput={(params) => (
                    <TextField fullWidth size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* 👇 naya Warning dropdown — Date Left ki jagah */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Warning"
                fullWidth
                size="small"
                name="WarningStatus"
                value={editData.WarningStatus || ""}
                onChange={_handleEditChange}
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="First Warning Issued">
                  First Warning Issued
                </MenuItem>
                <MenuItem value="Second Warning Issued">
                  Second Warning Issued
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Marital Status"
                fullWidth
                size="small"
                name="MaritalStatus"
                value={editData.MaritalStatus || ""}
                onChange={_handleEditChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Single">Single</MenuItem>
                <MenuItem value="Married">Married</MenuItem>
                <MenuItem value="Divorced">Divorced</MenuItem>
                <MenuItem value="Widowed">Widowed</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Qualification"
                fullWidth
                size="small"
                name="QualificationId"
                value={editData.QualificationId || ""}
                onChange={_handleEditChange}
              >
                {qualifications.map((q) => (
                  <MenuItem key={q.QualificationId} value={q.QualificationId}>
                    {q.Qualification}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Certificate"
                fullWidth
                size="small"
                name="CertificateId"
                value={editData.CertificateId || ""}
                onChange={_handleEditChange}
              >
                {certifications.map((c) => (
                  <MenuItem key={c.CertificateId} value={c.CertificateId}>
                    {c.CertificateName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Experience of Teaching in Years"
                fullWidth
                size="small"
                name="ExperienceOfTeaching"
                value={editData.ExperienceOfTeaching || ""}
                onChange={_handleEditChange}
              >
                {EXPERIENCE_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Subject of Experience"
                fullWidth
                size="small"
                name="SubjectOfExperience"
                value={editData.SubjectOfExperience || ""}
                onChange={_handleEditChange}
              >
                {(subjects || []).map((s) => (
                  <MenuItem key={s.ID} value={s.SubjectName}>
                    {s.SubjectName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Hired Subject"
                fullWidth
                size="small"
                name="HiredSubject"
                // value={editData.HiredSubject || ""}
                value={
                  subjects
                    .find(
                      (s) =>
                        String(s.ID) === String(editData.HiredSubject) ||
                        s.SubjectName === editData.HiredSubject,
                    )
                    ?.ID?.toString() || ""
                }
                onChange={_handleEditChange}
              >
                {(subjects || []).map((s) => (
                  <MenuItem key={s.ID} value={String(s.ID)}>
                    {s.SubjectName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Type of Hiring"
                fullWidth
                size="small"
                name="TypeOfHiring"
                value={editData.TypeOfHiring || ""}
                onChange={_handleEditChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Replacement">Replacement</MenuItem>
                <MenuItem value="New Teacher">New Teacher</MenuItem>
                <MenuItem value="Helper">Helper</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Allowance"
                fullWidth
                size="small"
                type="number"
                name="Allowance"
                value={editData.Allowance || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="First Salary"
                fullWidth
                size="small"
                type="number"
                name="FirstSalary"
                value={editData.FirstSalary || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Salary Demand"
                fullWidth
                size="small"
                name="SalaryDemand"
                value={editData.SalaryDemand || ""}
                onChange={_handleEditChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Primary / Secondary"
                fullWidth
                size="small"
                name="IsPrimary"
                value={_mapIsPrimary(editData.IsPrimary)}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    IsPrimary: e.target.value,
                  }))
                }
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="Primary">Primary</MenuItem>
                <MenuItem value="Secondary">Secondary</MenuItem>
                <MenuItem value="KG">KG</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Bank Account"
                fullWidth
                size="small"
                name="BankAccount"
                value={editData.BankAccount || ""}
                onChange={_handleEditChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <LoadingButton onClick={_onEditSubmit} variant="contained">
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {/* ---------------- TEACHER EXIT DIALOG ---------------- */}
      <Dialog fullWidth maxWidth="sm" open={openExit} onClose={handleExitClose}>
        <DialogTitle>Teacher Exit</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  label="Date Left"
                  inputFormat="DD-MM-YYYY"
                  value={exitData.DateLeft || null}
                  onChange={(newValue) =>
                    setExitData((prev) => ({
                      ...prev,
                      DateLeft: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : null,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField fullWidth size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Reason for Leaving"
                fullWidth
                size="small"
                name="ReasonForLeaving"
                value={exitData.ReasonForLeaving || ""}
                onChange={_handleExitChange}
              >
                {reasonOptions.map((r) => (
                  <MenuItem key={r.ID} value={r.Caption}>
                    {r.Caption}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Status"
                fullWidth
                size="small"
                name="LeftStatus"
                value={exitData.LeftStatus || ""}
                onChange={_handleExitChange}
              >
                <MenuItem value="Resigned">Resigned</MenuItem>
                <MenuItem value="Terminated">Terminated</MenuItem>
                <MenuItem value="Retired">Retired</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleExitClose}>Cancel</Button>
          <LoadingButton
            onClick={_onExitSubmit}
            variant="contained"
            color="error"
          >
            Confirm Exit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
}
